import { makeStyles } from "tss-react/mui"
import { inputStyles } from "../../assets/inputStyles"
import { spacing } from "../../assets/spacing"

export const useFieldsStyles = makeStyles()((theme) => ({
    ...inputStyles(theme),
    ...spacing(theme),

    // common
    background: {
        backgroundColor: theme.palette.background.paper,
    },
    inline: {
        display: "inline-block",
    },
    placeholder: {
        color: theme.palette.text.secondary,
    },

    // specific
    select: {
        backgroundColor: theme.palette.background.paper,
    },
}))
